import { ReactComponent as Logo } from '../../images/TellyLogo.svg'
import { useMount } from 'react-use'
import {
  Container,
  Wrapper,
  Header,
  Title,
  LogoContainer,
  Main,
  Message,
  Text,
  RightBackground,
  Footer,
  GoToTellyApp,
} from '../MobileApp/MobileApp.styles'
import { getDownloadUrl } from 'constants/appStores'

/**
 * Platform-aware app download link (https://app.teevee.com/app).
 *
 * Immediately redirects to the App Store on iOS, the Play Store on Android
 * and telly.com everywhere else. The page body is only visible when the
 * redirect is blocked (e.g. by a browser setting), as a manual fallback.
 *
 * Shared from the mobile app (Refer a Friend) — see TV1-32606.
 */
export const GetApp: React.FC = (): JSX.Element => {
  useMount(() => {
    location.replace(getDownloadUrl(navigator.userAgent))
  })

  return (
    <Wrapper>
      <Header>
        <LogoContainer>
          <Logo />
        </LogoContainer>
      </Header>

      <Main>
        <Container>
          <Title>almost there!</Title>
          <Message>Taking you to the Telly mobile app…</Message>
          <Text>If nothing happens, use the button below to get the app.</Text>
          <GoToTellyApp href={getDownloadUrl(navigator.userAgent)}>
            Download the App
          </GoToTellyApp>
        </Container>
        <RightBackground />
      </Main>
      <Footer />
    </Wrapper>
  )
}
